// Max Upload file size — matches the server's MAX_RESUME_SIZE_MB (20 MB)
// for resume uploads; the JD upload keeps its own limit below.
export const MAX_FILE_UPLOAD = 20;
export const MAX_JD_FILE_UPLOAD_MB = 20;

// Removes {, }, "
export const CLEAN_STRING_REGEX = /[{}"]/g;

// Phone Regex
// export const PHONE_REGEX = /^\+?(?=(?:.*\d){7,15}$)[\d\s\-().+]{7,20}$/;
// Date Regex — MM/YYYY, YYYY, or Present
export const DATE_REGEX = /^(\d{2}\/\d{4}|\d{4}|[Pp]resent)$/;

// DAte Regex - YYYY or Present
export const DATE_REGEX_WITH_YEAR_ONLY = /^\d{4}$|^[Pp]resent$/;

// Cert date — more flexible: "Sep 2023", "2023", "09/2023", "Present"
export const CERT_DATE_REGEX = /^([A-Za-z]{3,9}\s)?\d{4}$|^\d{2}\/\d{4}$/;

// Name Regex
export const NAME_REGEX = /^[a-zA-Z\s'.-]*$/;

// Text only — no digits (for names, titles, locations, languages)
export const TEXT_ONLY_REGEX = /^[a-zA-Z\s,.''\-()&/]+$/;

// LinkedIn URL Regex
export const LINKEDIN_REGEX = /^(https?:\/\/)?([a-z]{2,3}\.)?(www\.)?linkedin\.com\/[^\s]+$/i;

// GitHub URL Regex
export const GITHUB_REGEX = /^(https?:\/\/)?(www\.)?github\.com\/[a-zA-Z0-9-]+\/?$/;

// Grade: 8.5/10 | 3.5/4.0 | 75% | A+ | First Class
export const GRADE_REGEX = /^[0-9a-zA-Z\s./%+\-,:()*]+$/;

// Duration: "3 months", "6 weeks", "1 year", "Jan 2023 - Mar 2023", "2 months 3 weeks"
export const DURATION_REGEX = /^(\d+\s*(year|month|week|day)s?(\s*\d+\s*(year|month|week|day)s?)?|[A-Za-z]{3,9}\s\d{4}\s*[-–]\s*([A-Za-z]{3,9}\s\d{4}|[Pp]resent))$/i;

// Salary: digits + currency + common units, no weird special chars
export const SALARY_REGEX = /^[0-9\s.,\-+LKkMmCTCctcPA£$€/peryrannually]*$/i;

// Credential ID: alphanumeric + common separators
export const CREDENTIAL_ID_REGEX = /^[a-zA-Z0-9\s\-_.:/#]+$/;

export const DEGREE_REGEX = /^(10(th)?(\s\w+)?|12(th)?(\s\w+)?|[a-zA-Z][a-zA-Z0-9\s.,()&/+\-']{1,100})$/i;

export const NUMBER_REGEX = /^\d+$/;

// export const SKILL_REGEX = /^(?=.*[A-Za-z])[A-Za-z0-9\s.+#&/,\-():[\]'"]+$/;

export const LANGUAGE_REGEX = /^[A-Za-zÀ-ÖØ-öø-ÿ\s'-]+$/;

export const EXPERIENCE_REGEX =
  /^(100|([0-9]{1,2})(\.(0?[0-9]|1[0-1]))?)$/;

// Function to create a dynamic regex for 'n' digits
export const createNumberRegex = (n) => {
  return new RegExp(`^\\d{${n}}$`);
};
